export default "__VITE_ASSET__DRnu1P$k__"